const BasicErrorButton = (props) =>
    <button type="button" className="inline-flex items-center rounded-md py-2 px-4 text-sm font-medium shadow-sm
    bg-red-500 dark:bg-red-600 text-white hover:bg-red-600 dark:hover:bg-red-500
    disabled:opacity-70 hover:disabled:bg-red-500 dark:hover:disabled:bg-red-600" {...props}/>

export default BasicErrorButton;